// import React, { useState, useEffect } from 'react';
// import { FaUsers, FaClipboardList, FaCheckCircle, FaBullseye, FaBell, FaExclamationTriangle, } from 'react-icons/fa';

// const Home = () => {
//   const [leadCount, setLeadCount] = useState(0);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     const fetchLeadCount = async () => {
//       try {
//         const user = JSON.parse(sessionStorage.getItem("userData"));
//         if (!user?.id) {
//           throw new Error("User ID not found");
//         }
//         const res = await fetch(`https://cloudapi.emedhatechnologies.com/pages/api/lead_management?user_id=${user.id}`);
//         if (!res.ok) {
//           throw new Error('Network response was not ok');
//         }
//         const data = await res.json();
//         if (Array.isArray(data)) {
//           setLeadCount(data.length);
//         } else {
//           console.warn('Unexpected response format:', data);
//           setLeadCount(0);
//         }
//       } catch (err) {
//         console.error('Failed to fetch lead count:', err);
//         setError('Unable to load leads');
//       }
//     };

//     fetchLeadCount();
//   }, []);


//   return (
//     <div style={{ fontSize: '14px', color: '#333', padding: '20px', fontFamily: 'sans-serif' }}>
//       <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
//         <FaClipboardList /> Sales Dashboard
//       </h2>

//       {error && (
//         <div style={{ padding: '10px', backgroundColor: '#f9f9f9', border: '1px solid #ccc', borderRadius: '5px', marginBottom: '15px', }}>
//           {error}
//         </div>
//       )}

//       {/* Stats Cards */}
//       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
//         {[
//           { label: 'LEADS', value: leadCount, icon: <FaUsers /> },
//           { label: 'ORDERS', value: 1, icon: <FaClipboardList /> },
//           { label: 'CONVERSIONS', value: 0, icon: <FaCheckCircle /> }
//         ].map((card, idx) => (
//           <div key={idx} style={{ background: '#fff', border: '1px solid #e0e0e0', padding: '15px', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', gap: '10px' }}>
//             <div>{card.label}</div>
//             <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{card.value}</div>
//             <div style={{ color: '#555' }}>{card.icon}</div>
//           </div>
//         ))}
//       </div>

//       {/* Monthly Sales Target */}
//       <div style={{ marginTop: '25px', background: '#fff', borderRadius: '6px', padding: '15px', border: '1px solid #e0e0e0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px', color: '#444', }}>
//           <FaBullseye />
//           <strong>Monthly Sales Target</strong>
//         </div>
//         <div>Target: 100 Orders | Achieved: 1</div>
//         <div style={{ background: '#e0e0e0', height: '8px', borderRadius: '4px', marginTop: '8px', }}>
//           <div style={{ width: '1%', background: '#888', height: '100%', borderRadius: '4px' }}></div>
//         </div>
//       </div>

//       {/* Follow-ups & Inventory Alerts */}
//       <div style={{ marginTop: '25px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
//         {/* Follow-ups */}
//         <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '15px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//             <FaBell />
//             <strong>Follow-ups Due Today</strong>
//           </div>
//           <div style={{ marginTop: '10px', padding: '10px', background: '#f5f5f5', borderRadius: '4px', display: 'flex', justifyContent: 'space-between' }}>
//             <span>Lead #1</span>
//             <span style={{ fontSize: '12px', color: '#777', background: '#ddd', padding: '2px 6px', borderRadius: '12px' }}>
//               Invalid Date
//             </span>
//           </div>
//         </div>

//         {/* Inventory Alerts */}
//         <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '15px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//             <FaExclamationTriangle />
//             <strong>Inventory Alerts</strong>
//           </div>
//           {['6mm Veneer - Walnut', '18mm Plywood - Teak'].map((item, i) => (
//             <div key={i} style={{ marginTop: '10px', padding: '10px', background: '#f5f5f5', borderRadius: '4px' }}>
//               {item}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };





// export default Home;



// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { FaUsers, FaClipboardList, FaChartLine, FaShoppingBag } from 'react-icons/fa';

// const Home = () => {
//   const [leadCount, setLeadCount] = useState(0);
//   const [leads, setLeads] = useState([]);
//   const [showLeadsTable, setShowLeadsTable] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 5;
//   const [searchQuery, setSearchQuery] = useState('');
//   const [executives, setExecutives] = useState([]);
//   const [selectedExecutive, setSelectedExecutive] = useState('');
//   // 🔹 PRODUCTS STATES
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [showProductsTable, setShowProductsTable] = useState(false);
//   const [productLoading, setProductLoading] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState('');



//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(true);




//   const user = JSON.parse(sessionStorage.getItem("userData"));


//   // ✅ COMPANY ID FOR PRODUCTS API
//   const userId = user
//     ? user.type === "employee"
//       ? user.parent_company_id
//       : user.id
//     : null;


//   const showExecutiveSelect =
//     user?.type === "company" ||
//     (user?.type === "employee" && user?.user_type === "Manager");


//   const canViewProducts =
//     user?.type === "company" ||
//     (user?.type === "employee" && user?.permissions?.product_master === 1);


//   const stats = [
//     ...(canViewProducts
//       ? [
//         {
//           id: 1,
//           label: 'TOTAL PRODUCTS',
//           value: products.length,

//           icon: <FaShoppingBag />,
//           color: 'linear-gradient(135deg, #273179 0%, #002f3f 100%)'
//         }
//       ]
//       : []),

//     {
//       id: 2,
//       label: 'TOTAL LEADS',
//       value: leadCount,
//       icon: <FaUsers />,
//       color: 'linear-gradient(135deg, #273179 0%, #02adf0 100%)'
//     },
//     {
//       id: 3,
//       label: 'TOTAL ORDERS',
//       value: 1,
//       icon: <FaClipboardList />,
//       color: 'linear-gradient(135deg, #002f3f 0%, #02adf0 100%)'
//     }
//   ];



//   // 🔹 FETCH PRODUCTS
//   const fetchProducts = async () => {
//     if (!canViewProducts || !userId) return;

//     try {
//       setProductLoading(true);

//       const res = await axios.get(
//         `https://cloudapi.emedhatechnologies.com/pages/api/api/products/${userId}`
//       );

//       const data = Array.isArray(res.data) ? res.data : [];
//       setProducts(data);
//       setFilteredProducts(data);

//     } catch (err) {
//       console.error("Products fetch failed", err);
//     } finally {
//       setProductLoading(false);
//     }
//   };


//   const fetchLeads = async () => {
//     try {
//       setLoading(true);

//       const user = JSON.parse(sessionStorage.getItem("userData"));
//       if (!user) return;

//       const params = {
//         user_id: user.type === "company" ? user.id : user.parent_company_id,
//       };

//       if (user.type === "company") {
//         params.role = "company";
//       } else if (user.type === "employee" && user.user_type === "Manager") {
//         params.role = "manager";
//         params.employee_id = user.id;
//       } else if (user.type === "employee" && user.user_type === "Executive") {
//         params.role = "executive";
//         params.employee_id = user.id;
//       }

//       const res = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/dashboard/leads",
//         params
//       );

//       const data = Array.isArray(res.data) ? res.data : [];

//       setLeads(data);
//       setLeadCount(data.length);

//     } catch (err) {
//       console.error(err);
//       setError("Unable to load leads");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeads();
//   }, []);


//   useEffect(() => {
//     fetchLeads();
//   }, []);



//   useEffect(() => {
//     if (!showExecutiveSelect) return;

//     const payload =
//       user.type === "company"
//         ? { company_id: user.id }
//         : { manager_id: user.id };

//     fetch("https://cloudapi.emedhatechnologies.com/pages/api/api/get-sales-executives", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) setExecutives(data.data);
//       });
//   }, [showExecutiveSelect]);

//   // 🔹 LOAD PRODUCTS ON PAGE LOAD
//   useEffect(() => {
//     if (canViewProducts) {
//       fetchProducts();
//       setShowProductsTable(true); // 👈 show table by default
//     }
//   }, [canViewProducts]);

//   // 🔹 UNIQUE CATEGORIES
//   const categories = [...new Set(products.map(p => p.category))];

//   // 🔹 FILTER BY CATEGORY
//   useEffect(() => {
//     if (!selectedCategory) {
//       setFilteredProducts(products);
//     } else {
//       setFilteredProducts(
//         products.filter(p => p.category === selectedCategory)
//       );
//     }
//   }, [selectedCategory, products]);


//   const filteredLeads = leads.filter(lead => {
//     const q = searchQuery.toLowerCase();
//     return (
//       lead.name?.toLowerCase().includes(q) ||
//       lead.contact?.toLowerCase().includes(q) ||
//       lead.location?.toLowerCase().includes(q)
//     ) && (!selectedExecutive || lead.executive_name === selectedExecutive);
//   });

//   const totalPages = Math.ceil(filteredLeads.length / rowsPerPage);

//   const paginatedLeads = filteredLeads.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );


//   return (
//     <>
//       <div style={{ display: "flex", flexDirection: "column", gap: "24px", boxSizing: "border-box", width: "100%", }}>
//         {/* Header Section */}
//         <div style={{ marginBottom: "16px" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "24px", fontWeight: "600" }}><FaChartLine style={{ color: "var(--accent)" }} />Dashboard</div>
//           <div style={{ fontSize: "14px", color: "#666", marginTop: "4px" }}>Overview of your current performance metrics</div>
//         </div>
//         {/* Error Handling */}
//         {error && (
//           <div style={{ backgroundColor: "#ffdddd", color: "#a00", padding: "12px", borderRadius: "8px", fontWeight: "500", }}>{error}</div>
//         )}

//         {/* Cards Grid */}
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "16px", }}>
//           {stats.map((card) => (
//             <div key={card.id}
//               onClick={() => {
//                 if (card.id === 2) {
//                   setShowLeadsTable((prev) => !prev);
//                   setShowProductsTable(false);
//                 }
//                 if (card.id === 1) {
//                   setShowProductsTable((prev) => !prev);
//                   setShowLeadsTable(false);
//                 }
//               }}
//               style={{ position: "relative", background: card.color, borderRadius: "12px", padding: "16px", cursor: "pointer", overflow: "hidden", color: "#fff", display: "flex", flexDirection: "column", gap: "12px", minHeight: "120px", }}>
//               {/* Decorative Background Shape */}
//               <div style={{ position: "absolute", top: "-20px", right: "-20px", width: "80px", height: "80px", borderRadius: "50%", background: "rgba(255, 255, 255, 0.2)", transform: "rotate(45deg)", }}></div>
//               {/* Icon */}
//               <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "rgba(255,255,255,0.3)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1, }}>{card.icon}</div>
//               {/* Value */}
//               <div style={{ fontSize: "24px", fontWeight: "700", zIndex: 1 }}>{loading && card.id === 1 ? "..." : card.value}</div>
//               {/* Label */}
//               <div style={{ fontSize: "14px", fontWeight: "500", zIndex: 1 }}>{card.label}</div>
//             </div>
//           ))}
//         </div>
//       </div>



//       {showLeadsTable && (
//         <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%", marginTop: '20px' }}>

//           {/* CONTROLS */}
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
//             <input type="text" placeholder="Search by name, mobile, location..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} style={{ flex: "1 1 200px", padding: "8px", fontSize: "14px" }} />
//             {showExecutiveSelect && (
//               <select value={selectedExecutive} onChange={(e) => { setSelectedExecutive(e.target.value); setCurrentPage(1); }} style={{ flex: "1 1 150px", padding: "8px", fontSize: "14px" }}>
//                 <option value="">All Executives</option>
//                 {executives.map((exec) => (
//                   <option key={exec.id} value={exec.name}>{exec.name}</option>
//                 ))}
//               </select>
//             )}
//           </div>
//           {/* HEADER */}
//           <h3 style={{ margin: 0 }}>Total Leads ({leadCount})</h3>
//           {/* LOADING / EMPTY */}
//           {loading && <div style={{ textAlign: "center", padding: "16px" }}>Loading leads...</div>}
//           {!loading && paginatedLeads.length === 0 && (<div style={{ textAlign: "center", padding: "16px" }}>No leads found</div>)}

//           {/* LEAD CARDS */}
//           <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//             {!loading && paginatedLeads.map((lead, index) => (
//               <div key={lead.id || index} style={{ border: "1px solid #ddd", borderRadius: "12px", padding: "12px", background: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", }}>
//                 {/* ROW 1 */}
//                 <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
//                   <div><strong>#</strong> {index + 1}</div>
//                   <div>
//                     <span style={{ padding: "4px 10px", borderRadius: "20px", background: "#e0e0e0", fontSize: "12px", }}> {lead.status || "New"}</span>
//                   </div>
//                 </div>
//                 {/* ROW 2 */}
//                 <div style={{ marginBottom: "6px" }}><strong>Name:</strong> {lead.name || "-"}</div>
//                 {/* ROW 3 */}
//                 <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px" }}>
//                   <div><strong>Phone:</strong> {lead.contact || "-"}</div>
//                   <div><strong>Location:</strong> {lead.location || "-"}</div>
//                 </div>
//                 {/* ROW 4 */}
//                 <div style={{ marginBottom: "6px" }}><strong>Requirement:</strong> {lead.requirement || "-"}</div>
//                 {/* ROW 5 */}
//                 <div><strong>Executive:</strong> {lead.executive_name || "-"}</div>
//               </div>
//             ))}
//           </div>
//           {/* PAGINATION */}
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "8px", flexWrap: "wrap", gap: "8px", }}>
//             <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} style={{ padding: "6px 12px", cursor: currentPage === 1 ? "not-allowed" : "pointer", }}>Prev</button>
//             <span>Page {currentPage} of {totalPages}</span>
//             <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} style={{ padding: "6px 12px", cursor: currentPage === totalPages ? "not-allowed" : "pointer", }}> Next</button>
//           </div>
//         </div>
//       )}


//       {showProductsTable && canViewProducts && (
//         <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%", boxSizing: "border-box", marginTop: '20px' }}>
//           {/* 🔹 FILTER CONTROLS */}
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
//             <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} style={{ flex: "1 1 200px", padding: "8px", fontSize: "14px" }}>
//               <option value="">All Categories</option>
//               {categories.map((cat) => (<option key={cat} value={cat}>{cat}</option>))}
//             </select>
//           </div>
//           {/* 🔹 HEADER */}
//           <h3 style={{ margin: 0 }}>Total Products ({filteredProducts.length})</h3>
//           {/* 🔹 LOADING / EMPTY */}
//           {productLoading && (<div style={{ textAlign: "center", padding: "16px" }}>Loading products...</div>)}
//           {!productLoading && filteredProducts.length === 0 && (<div style={{ textAlign: "center", padding: "16px" }}>No products found</div>)}
//           {/* 🔹 PRODUCT CARDS */}
//           <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//             {!productLoading && filteredProducts.map((product, index) => product.variants.map((variant) => (
//               <div key={`${product.id}-${variant.id}`} style={{ background: "#fff", borderRadius: "12px", padding: "12px", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", border: "1px solid #ddd", }}>
//                 {/* ROW 1 */}
//                 <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px", }}>
//                   <div><strong>#</strong> {index + 1}</div>
//                   <div><strong>Qty:</strong> {variant.qty}</div>
//                 </div>
//                 {/* ROW 2 */}
//                 <div style={{ marginBottom: "6px" }}><strong>Category:</strong> {product.category}</div>
//                 {/* ROW 3 */}
//                 <div style={{ marginBottom: "6px" }}><strong>Subcategory:</strong> {product.subcategory}</div>
//                 {/* ROW 4 */}
//                 <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "6px", }}>
//                   <div><strong>Code:</strong> {variant.code}</div>
//                   <div><strong>Size:</strong> {variant.size}</div>
//                 </div>
//               </div>
//             ))
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Home;

import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { FaUsers, FaClipboardList, FaChartLine, FaShoppingBag } from 'react-icons/fa';
import { MapPin, Phone, User, Search, ArrowUpRight } from 'lucide-react';
import { 
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from 'recharts';

const STATS_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#a855f7', '#6366f1', '#ef4444'];

// Clean Minimal Dashboard Inline Styles Object Matrix
const styles = {
  container: { maxWidth: '1280px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif', backgroundColor: '#f9fafb', color: '#111827', boxSizing: 'border-box' },
  headerSection: { marginBottom: '24px' },
  title: { fontSize: '26px', fontWeight: '900', letterSpacing: '-0.5px', margin: '0 0 4px 0', color: '#111827', display: 'flex', alignItems: 'center', gap: '10px' },
  subtitle: { fontSize: '14px', color: '#6b7280', margin: 0 },
  errorCard: { backgroundColor: '#fef2f2', border: '1px solid #fee2e2', color: '#991b1b', padding: '12px 16px', borderRadius: '8px', fontSize: '13px', fontWeight: '500', marginBottom: '20px' },
  
  // KPI Interactive Click Cards Grid 
  kpiGrid: { display: 'grid', gap: '20px', marginBottom: '24px' },
  kpiCard: (gradientBg) => ({ position: 'relative', background: gradientBg, borderRadius: '14px', padding: '20px', cursor: 'pointer', overflow: 'hidden', color: '#ffffff', display: 'flex', flexDirection: 'column', gap: '12px', minHeight: '120px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', boxSizing: 'border-box' }),
  kpiShape: { position: 'absolute', top: '-20px', right: '-20px', width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255, 255, 255, 0.15)', transform: 'rotate(45deg)' },
  kpiIconRing: { width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '16px', zIndex: 1 },
  kpiValue: { fontSize: '26px', fontWeight: '900', zIndex: 1, margin: 0 },
  kpiLabel: { fontSize: '12px', fontWeight: '700', letterSpacing: '0.05em', textTransform: 'uppercase', zIndex: 1, margin: 0, opacity: 0.9 },

  // Control Filter Bar Cards
  filterCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', boxSizing: 'border-box' },
  searchWrapper: { position: 'relative', flex: '1 1 260px' },
  searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '14px', height: '14px', color: '#9ca3af' },
  searchInput: { width: '100%', padding: '10px 12px 10px 38px', fontSize: '13px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', boxSizing: 'border-box' },
  selectInput: { flex: '1 1 200px', padding: '10px 12px', fontSize: '13px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none', color: '#111827', cursor: 'pointer', boxSizing: 'border-box' },

  // Visualizations Dynamic Chart Panels
  chartGrid: { display: 'grid', gap: '24px', marginBottom: '24px' },
  chartCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)', boxSizing: 'border-box' },
  chartHeader: { marginBottom: '16px' },
  chartTitle: { fontSize: '16px', fontWeight: '700', color: '#111827', margin: '0 0 2px 0' },
  chartSubtitle: { fontSize: '12px', color: '#6b7280', margin: 0 },
  pieLabelRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '12px', padding: '4px 0' },

  // Layout Dynamic Content Panels Splits
  sectionTitle: { fontSize: '16px', fontWeight: '800', color: '#111827', margin: '0 0 14px 0', borderLeft: '4px solid #2563eb', paddingLeft: '10px' },
  stateNotice: { textAlign: 'center', padding: '32px 16px', color: '#6b7280', fontSize: '13px', backgroundColor: '#ffffff', border: '1px dashed #e5e7eb', borderRadius: '12px' },
  streamStack: { display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' },
  entityCard: { backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)', display: 'flex', flexDirection: 'column', gap: '12px', boxSizing: 'border-box' },
  entityHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f3f4f6', paddingBottom: '8px' },
  indexBadge: { fontSize: '11px', fontWeight: '700', backgroundColor: '#f3f4f6', color: '#4b5563', padding: '2px 8px', borderRadius: '4px', fontFamily: 'monospace' },
  statusBadge: (status) => {
    let bg = '#e0e0e0', text = '#333333';
    const s = String(status).toUpperCase();
    if (s === 'INTERESTED') { bg = '#d1fae5'; text = '#065f46'; }
    else if (s === 'CALLBACK') { bg = '#fef3c7'; text = '#92400e'; }
    else if (s === 'NEW' || s === 'LEAD') { bg = '#dbeafe'; text = '#1e40af'; }
    return { padding: '4px 10px', borderRadius: '9999px', fontSize: '11px', fontWeight: '800', backgroundColor: bg, color: text, textTransform: 'uppercase' };
  },
  entityInfoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', fontSize: '13px' },
  itemRow: { display: 'flex', alignItems: 'center', gap: '8px', color: '#374151' },
  itemIcon: { color: '#9ca3af', width: '15px', height: '15px', flexShrink: 0 },
  requirementBlock: { backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px 12px', fontSize: '13px', color: '#111827', margin: 0, fontWeight: '500' },
  
  // Footer Pagination Elements
  paginationBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', flexWrap: 'wrap', gap: '12px', paddingTop: '14px', borderTop: '1px solid #e5e7eb' },
  pageBtn: (disabled) => ({ padding: '8px 16px', fontSize: '12px', fontWeight: '600', backgroundColor: disabled ? '#f3f4f6' : '#ffffff', color: disabled ? '#9ca3af' : '#374151', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: disabled ? 'not-allowed' : 'pointer' }),
  pageText: { fontSize: '13px', color: '#4b5563', fontWeight: '500' }
};

const Home = () => {
  const [leadCount, setLeadCount] = useState(0);
  const [leads, setLeads] = useState([]);
  const [showLeadsTable, setShowLeadsTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const [searchQuery, setSearchQuery] = useState('');
  const [executives, setExecutives] = useState([]);
  const [selectedExecutive, setSelectedExecutive] = useState('');
  
  // PRODUCTS STATES
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showProductsTable, setShowProductsTable] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(sessionStorage.getItem("userData"));

  // COMPANY ID FOR PRODUCTS API
  const userId = user
    ? user.type === "employee"
      ? user.parent_company_id
      : user.id
    : null;

  const showExecutiveSelect =
    user?.type === "company" ||
    (user?.type === "employee" && user?.user_type === "Manager");

  const canViewProducts =
    user?.type === "company" ||
    (user?.type === "employee" && user?.permissions?.product_master === 1);

  const stats = [
    ...(canViewProducts
      ? [
        {
          id: 1,
          label: 'TOTAL PRODUCTS',
          value: products.length,
          icon: <FaShoppingBag />,
          color: 'linear-gradient(135deg, #273179 0%, #002f3f 100%)'
        }
      ]
      : []),
    {
      id: 2,
      label: 'TOTAL LEADS',
      value: leadCount,
      icon: <FaUsers />,
      color: 'linear-gradient(135deg, #273179 0%, #02adf0 100%)'
    },
    {
      id: 3,
      label: 'TOTAL ORDERS',
      value: 1,
      icon: <FaClipboardList />,
      color: 'linear-gradient(135deg, #002f3f 0%, #02adf0 100%)'
    }
  ];

  // FETCH PRODUCTS
  const fetchProducts = async () => {
    if (!canViewProducts || !userId) return;

    try {
      setProductLoading(true);
      const res = await axios.get(
        `https://cloudapi.emedhatechnologies.com/pages/api/api/products/${userId}`
      );
      const data = Array.isArray(res.data) ? res.data : [];
      setProducts(data);
      setFilteredProducts(data);
    } catch (err) {
      console.error("Products fetch failed", err);
    } finally {
      setProductLoading(false);
    }
  };

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const user = JSON.parse(sessionStorage.getItem("userData"));
      if (!user) return;

      const params = {
        user_id: user.type === "company" ? user.id : user.parent_company_id,
      };

      if (user.type === "company") {
        params.role = "company";
      } else if (user.type === "employee" && user.user_type === "Manager") {
        params.role = "manager";
        params.employee_id = user.id;
      } else if (user.type === "employee" && user.user_type === "Executive") {
        params.role = "executive";
        params.employee_id = user.id;
      }

      const res = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/dashboard/leads",
        params
      );

      const data = Array.isArray(res.data) ? res.data : [];
      setLeads(data);
      setLeadCount(data.length);
    } catch (err) {
      console.error(err);
      setError("Unable to load leads");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  useEffect(() => {
    if (!showExecutiveSelect || !user.id) return;

    const payload =
      user.type === "company"
        ? { company_id: user.id }
        : { manager_id: user.id };

    fetch("https://cloudapi.emedhatechnologies.com/pages/api/api/get-sales-executives", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setExecutives(data.data);
      });
  }, [showExecutiveSelect]);

  // LOAD PRODUCTS ON PAGE LOAD
  useEffect(() => {
    if (canViewProducts) {
      fetchProducts();
      setShowProductsTable(true);
    }
  }, [canViewProducts]);

  // UNIQUE CATEGORIES
  const categories = [...new Set(products.map(p => p.category))];

  // FILTER BY CATEGORY
  useEffect(() => {
    if (!selectedCategory) {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(
        products.filter(p => p.category === selectedCategory)
      );
    }
  }, [selectedCategory, products]);

  const filteredLeads = leads.filter(lead => {
    const q = searchQuery.toLowerCase();
    return (
      lead.name?.toLowerCase().includes(q) ||
      lead.contact?.toLowerCase().includes(q) ||
      lead.location?.toLowerCase().includes(q)
    ) && (!selectedExecutive || lead.executive_name === selectedExecutive);
  });

  const totalPages = Math.ceil(filteredLeads.length / rowsPerPage) || 1;

  const paginatedLeads = filteredLeads.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // 📈 LIVE BAR CHART GENERATION GENERATOR ENGINE (Calculated using live API arrays)
  const barChartRealTimeData = Object.values(
    products.reduce((acc, currentItem) => {
      const cat = currentItem.category || "Uncategorized";
      // Sum the values of variants nested inside product streams
      const totalVolume = Array.isArray(currentItem.variants) 
        ? currentItem.variants.reduce((vSum, v) => vSum + (Number(v.qty) || 0), 0)
        : 0;

      if (!acc[cat]) {
        acc[cat] = { name: cat, stockVolume: 0 };
      }
      acc[cat].stockVolume += totalVolume;
      return acc;
    }, {})
  );

  // 📊 LIVE PIE CHART STATUS BREAKDOWN LOGIC MATRIX (Aggregated dynamically out of state fields)
  const pieChartRealTimeData = Object.values(
    leads.reduce((acc, leadItem) => {
      const rawStatus = leadItem.status || "New";
      const statusLabel = rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase();
      if (!acc[statusLabel]) {
        acc[statusLabel] = { name: statusLabel, value: 0 };
      }
      acc[statusLabel].value += 1;
      return acc;
    }, {})
  );

  return (
    <div style={styles.container}>
      {/* Component Breakpoint Injection Structural Layout Rules */}
      <style>{`
        .home-responsive-grid { grid-template-columns: 1fr; }
        .chart-responsive-grid { grid-template-columns: 1fr; }
        @media(min-width: 576px) {
          .home-responsive-grid { grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); }
        }
        @media (min-width: 992px) {
          .chart-responsive-grid { grid-template-columns: 2fr 1fr; }
        }
      `}</style>

      {/* Header Section */}
      <div style={styles.headerSection}>
        <div style={styles.title}>
          <FaChartLine style={{ color: '#273179' }} />
          <span>Dashboard Overview</span>
        </div>
        <div style={styles.subtitle}>Overview of your current performance metrics</div>
      </div>

      {/* Error Handling Notification Row */}
      {error && (
        <div style={styles.errorCard}>{error}</div>
      )}

      {/* Cards KPI Grid Display Component */}
      <div className="home-responsive-grid" style={styles.kpiGrid}>
        {stats.map((card) => (
          <div key={card.id}
            onClick={() => {
              if (card.id === 2) {
                setShowLeadsTable((prev) => !prev);
                setShowProductsTable(false);
              }
              if (card.id === 1) {
                setShowProductsTable((prev) => !prev);
                setShowLeadsTable(false);
              }
            }}
            style={styles.kpiCard(card.color)}
          >
            <div style={styles.kpiShape}></div>
            <div style={styles.kpiIconRing}>{card.icon}</div>
            <div style={styles.kpiValue}>
              {loading && card.id === 1 ? "..." : card.value}
            </div>
            <div style={styles.kpiLabel}>
              {card.label}
              <ArrowUpRight style={{ width: '12px', height: '12px', marginLeft: '4px', inlineSize: 'auto' }} />
            </div>
          </div>
        ))}
      </div>

      {/* Charts Visualizations Stream Block (Driven by actual parsed backend data objects) */}
      <div className="chart-responsive-grid" style={styles.chartGrid}>
        {/* Dynamic Bar Chart: Product Quantities Split By Categories */}
        <div style={styles.chartCard}>
          <div style={styles.chartHeader}>
            <h3 style={styles.chartTitle}>Stock Volume Analysis</h3>
            <p style={styles.chartSubtitle}>Real-time accumulated sheet quantities tracking map itemized by live database category matrices</p>
          </div>
          <div style={{ height: '240px', width: '100%' }}>
            <ResponsiveContainer width="100%" height="100%">
              {barChartRealTimeData.length === 0 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#9ca3af', fontSize: '13px' }}>No inventory product lines loaded for charting evaluation.</div>
              ) : (
                <BarChart data={barChartRealTimeData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
                  <XAxis dataKey="name" tick={{ fontSize: 10, fill: '#6b7280' }} stroke="#e5e7eb" />
                  <YAxis tick={{ fontSize: 10, fill: '#6b7280' }} stroke="#e5e7eb" />
                  <Tooltip cursor={{ fill: 'rgba(0,0,0,0.02)' }} />
                  <Bar dataKey="stockVolume" fill="#2563eb" radius={[4, 4, 0, 0]}>
                    {barChartRealTimeData.map((_, index) => (
                      <Cell key={`cell-${index}`} fill={STATS_COLORS[index % STATS_COLORS.length]} />
                    ))}
                  </Bar>
                </BarChart>
              )}
            </ResponsiveContainer>
          </div>
        </div>

        {/* Dynamic Pie Chart: Leads Distribution Split By Stage Status */}
        <div style={{ ...styles.chartCard, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div style={styles.chartHeader}>
            <h3 style={styles.chartTitle}>Lead Funnel Stage Ratios</h3>
            <p style={styles.chartSubtitle}>Live breakdown allocation calculated from client logging items</p>
          </div>

          <div style={{ height: '140px', position: 'relative', margin: 'auto 0' }}>
            <ResponsiveContainer width="100%" height="100%">
              {pieChartRealTimeData.length === 0 ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#9ca3af', fontSize: '13px' }}>No lead funnel pipeline statistics found.</div>
              ) : (
                <PieChart>
                  <Pie
                    data={pieChartRealTimeData}
                    cx="50%"
                    cy="50%"
                    innerRadius={45}
                    outerRadius={65}
                    paddingAngle={4}
                    dataKey="value"
                  >
                    {pieChartRealTimeData.map((_, index) => (
                      <Cell key={`cell-${index}`} fill={STATS_COLORS[index % STATS_COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              )}
            </ResponsiveContainer>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '10px' }}>
            {pieChartRealTimeData.map((item, index) => (
              <div key={item.name} style={styles.pieLabelRow}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: STATS_COLORS[index % STATS_COLORS.length] }}></div>
                  <span style={{ color: '#6b7280' }}>{item.name}</span>
                </div>
                <span style={{ fontWeight: '700', color: '#111827' }}>{item.value} Records</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CRM Leads Interaction Management Stack */}
      {showLeadsTable && (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%", marginTop: '24px' }}>
          
          {/* CONTROLS FILTERS BAR */}
          <div style={styles.filterCard}>
            <div style={styles.searchWrapper}>
              <Search style={styles.searchIcon} />
              <input 
                type="text" 
                placeholder="Search by name, mobile, location..." 
                value={searchQuery} 
                onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} 
                style={styles.searchInput} 
              />
            </div>
            {showExecutiveSelect && (
              <select value={selectedExecutive} onChange={(e) => { setSelectedExecutive(e.target.value); setCurrentPage(1); }} style={styles.selectInput}>
                <option value="">All Account Executives</option>
                {executives.map((exec) => (
                  <option key={exec.id} value={exec.name}>{exec.name}</option>
                ))}
              </select>
            )}
          </div>

          {/* HEADER */}
          <h3 style={styles.sectionTitle}>Pipeline Leads Tracking Stream ({leadCount})</h3>
          
          {/* CONDITIONALS PANELS CHANNELS */}
          {loading && <div style={styles.stateNotice}>Fetching real-time sales pipeline funnel items...</div>}
          {!loading && paginatedLeads.length === 0 && (<div style={styles.stateNotice}>No active leads data registered matching chosen filter attributes.</div>)}

          {/* STREAM CARD CONTENT MAP CONTAINER */}
          <div style={styles.streamStack}>
            {!loading && paginatedLeads.map((lead, index) => (
              <div key={lead.id || index} style={styles.entityCard}>
                <div style={styles.entityHeader}>
                  <span style={styles.indexBadge}>Pipeline Record #{((currentPage - 1) * rowsPerPage) + index + 1}</span>
                  <span style={styles.statusBadge(lead.status || "New")}>{lead.status || "New"}</span>
                </div>

                <div style={styles.entityInfoGrid}>
                  <div style={styles.itemRow}>
                    <User style={styles.itemIcon} />
                    <strong>Name:</strong> <span>{lead.name || "-"}</span>
                  </div>
                  <div style={styles.itemRow}>
                    <Phone style={styles.itemIcon} />
                    <strong>Phone Connection:</strong> <span style={{ fontFamily: 'monospace' }}>{lead.contact || "-"}</span>
                  </div>
                  <div style={styles.itemRow}>
                    <MapPin style={styles.itemIcon} />
                    <strong>Location:</strong> <span>{lead.location || "-"}</span>
                  </div>
                  <div style={styles.itemRow}>
                    <User style={{ ...styles.itemIcon, color: '#3b82f6' }} />
                    <strong>Assigned Representative:</strong> <span style={{ fontWeight: '600', color: '#273179' }}>{lead.executive_name || "-"}</span>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <span style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#6b7280' }}>Demanded Material Logs</span>
                  <p style={styles.requirementBlock}>{lead.requirement || "No specific requirement logs declared"}</p>
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION CONTROL BOARD */}
          <div style={styles.paginationBar}>
            <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} style={styles.pageBtn(currentPage === 1)}>Previous Stage</button>
            <span style={styles.pageText}>Page {currentPage} of {totalPages}</span>
            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} style={styles.pageBtn(currentPage === totalPages)}>Next Stage</button>
          </div>
        </div>
      )}

      {/* Synchronized Inventory Product Display Section */}
      {showProductsTable && canViewProducts && (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%", boxSizing: "border-box", marginTop: '24px' }}>
          
          {/* CATEGORIES DROPDOWN FILTERS CARD */}
          <div style={styles.filterCard}>
            <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} style={styles.selectInput}>
              <option value="">All Structural Categories</option>
              {categories.map((cat) => (<option key={cat} value={cat}>{cat}</option>))}
            </select>
          </div>

          {/* PANEL HEADER */}
          <h3 style={styles.sectionTitle}>Material Products Database Master ({filteredProducts.length})</h3>
          
          {/* EMPTY STATES CONFIGS */}
          {productLoading && (<div style={styles.stateNotice}>Synchronizing warehouse matrix sheets counts...</div>)}
          {!productLoading && filteredProducts.length === 0 && (<div style={styles.stateNotice}>No stock product rows verified for current selection category view.</div>)}

          {/* MAIN DYNAMIC CONTENT MAP BLOCKS */}
          <div style={styles.streamStack}>
            {!productLoading && filteredProducts.map((product, index) => product.variants.map((variant) => (
              <div key={`${product.id}-${variant.id}`} style={styles.entityCard}>
                <div style={styles.entityHeader}>
                  <span style={styles.indexBadge}>Product Sheet Line Record</span>
                  <span style={{ fontSize: '12px', fontWeight: '800', color: variant.qty === 0 ? '#dc2626' : '#059669', backgroundColor: variant.qty === 0 ? '#fee2e2' : '#d1fae5', padding: '4px 10px', borderRadius: '6px' }}>
                    Available: {variant.qty} Sheets
                  </span>
                </div>

                <div style={styles.entityInfoGrid}>
                  <div>
                    <span style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#6b7280', display: 'block' }}>Primary Family Category</span>
                    <strong style={{ color: '#111827', fontSize: '14px' }}>{product.category}</strong>
                  </div>
                  <div>
                    <span style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#6b7280', display: 'block' }}>Subcategory Blueprint Submodel</span>
                    <span style={{ color: '#374151', fontWeight: '500' }}>{product.subcategory}</span>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', backgroundColor: '#f9fafb', padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                  <div>
                    <span style={{ fontSize: '10px', textTransform: 'uppercase', fontWeight: '700', color: '#6b7280', display: 'block' }}>Veneer Model Variant Code</span>
                    <span style={{ fontFamily: 'monospace', fontWeight: '700', color: '#2563eb' }}>{variant.code || 'N/A'}</span>
                  </div>
                  <div>
                    <span style={{ fontSize: '10px', textTransform: 'uppercase', fontWeight: '700', color: '#6b7280', display: 'block' }}>Sheet Size Dimension</span>
                    <span style={{ fontFamily: 'monospace', fontWeight: '600', color: '#4b5563' }}>{variant.size || 'Standard Matrix'}</span>
                  </div>
                </div>
              </div>
            ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;